(() => {
  const initStory = (root) => {
    if (!root || root.dataset.ksqStoryReady === 'true') return;
    root.dataset.ksqStoryReady = 'true';

    const filters = [...root.querySelectorAll('[data-ksq-ingredient-filter]')];
    const cards = [...root.querySelectorAll('[data-ksq-ingredient-card]')];
    let activeFilter = 'all';

    const applyIngredientState = () => {
      cards.forEach((card) => {
        const matches = activeFilter === 'all' || card.dataset.ksqIngredientCard === activeFilter;
        card.hidden = !matches;
      });
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.ksqIngredientFilter || 'all';
        filters.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        applyIngredientState();
      });
    });

    applyIngredientState();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-ksq-product-story]').forEach(initStory);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
